import { Component } from '@angular/core';

@Component({
  selector: 'lib-page-under-construction',
  standalone: true,
  imports: [],
  templateUrl: './page-under-construction.component.html',
  styleUrl: './page-under-construction.component.scss'
})
export class PageUnderConstructionComponent {

}
